angular.module('impactx.basket').service('BasketService', [
    '$mdDialog',
    '$securityManager',
    'dataGen',
    BasketService
]);

function BasketService($mdDialog, $securityManager, dataGen) {
    var pageIndex = 0;
    var requestLandingPages = new Map();
    var demandLandingPages = new Map();

    function resolveLandingPage(param, isDemand) {
        var route = getBasketLandingPage(pageIndex, isDemand);
        if (param) {
            route = route.replace('?', param);
        }

        return route;
    }

    function getBasketLandingPage(landingPageIndex, isDemand) {
        if (isDemand) {
            return demandLandingPages.get(landingPageIndex);
        }
        return requestLandingPages.get(landingPageIndex);
    }

    function openBasketControlStructureDialog(event, trns, bks, bki, controls, showControl, saveBasketBackground, preselectControl, aatId, controlLabels) {
        return $mdDialog.show({
            controller: 'BasketControlStructureDialogCtrl',
            controllerAs: 'controlCtrl',
            templateUrl: 'modules/control/templates/basket-control-structure.dialog.html',
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            bindToController: true,
            locals: {
                trns: trns,
                aatId: aatId,
                bks: bks,
                bki: bki,
                controls: controls,
                showControl: showControl,
                saveBasketBackground: saveBasketBackground,
                preselectControl: preselectControl,
                hasControlLabels: controlLabels
            }
        });
    }

    function openBasketAddressDialog(event, trns, addresses, bksId, bkiId, title, regionCodeDeliveryAddress) {
        return $mdDialog.show({
            controller: 'BasketAddressDialogCtrl',
            controllerAs: 'addressCtrl',
            templateUrl: 'modules/control/templates/basket-address.dialog.html',
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            bindToController: true,
            multiple: true,
            locals: {
                trns: trns,
                addresses: addresses,
                bksId: bksId,
                bkiId: bkiId,
                customTitle: title,
                regionCodeDeliveryAddress: regionCodeDeliveryAddress
            }
        });
    }

    function openDatesDialog(event, trns, date, firstDate, lastDate, title, minDate, sendDistributionList) {
        return $mdDialog.show({
            controller: 'BasketDatesInputDialogCtrl',
            controllerAs: 'datesCtrl',
            templateUrl: 'modules/basket/templates/basket-date-input-dialog.tmpl.html',
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            bindToController: true,
            multiple: true,
            locals: {
                trns: trns,
                date: date,
                firstDate: firstDate,
                lastDate: lastDate,
                title: title,
                minDate: minDate,
                sendDistributionList: sendDistributionList || false
            }
        });
    }

    function openRequestedDatesDialog(event, trns, dateHolder, title, bksId, sendDistributionList) {
        return $mdDialog.show({
            controller: 'BasketRequestedDatesDialogCtrl',
            controllerAs: 'datesCtrl',
            templateUrl: 'modules/basket/templates/basket-requested-date-dialog.tmpl.html',
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            bindToController: true,
            multiple: true,
            locals: {
                trns: trns,
                dateHolder: dateHolder,
                title: title,
                bksId: bksId,
                sendDistributionList: sendDistributionList || false
            }
        });
    }

    function openServicePeriodDialog(event, servicePeriod, readOnly) {
        return $mdDialog.show({
            controller: "ServicePeriodCtrl",
            controllerAs: "servicePeriodCtrl",
            templateUrl: "modules/basket/templates/serviceperiod.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            locals: {
                servicePeriod: servicePeriod,
                readOnly: readOnly
            }
        });
    }

    function setLandingPageIndex(index) {
        pageIndex = index;
    }

    function initLandingPages() {
        requestLandingPages = new Map();
        requestLandingPages.set(0, $securityManager.isProcessAllowed("StatusSimple") ? '/simplepurchaserequestlist' : '/purchaserequestlist');
        requestLandingPages.set(1, '/approvalworkflow/?');

        demandLandingPages = new Map();
        demandLandingPages.set(0, '/demandlist');
        demandLandingPages.set(1, '/approvalworkflowdemand/?');
    }

    function openBulkChangeDialog(selectedBasketItems, bkhId, viewMode) {
        var selectedIds = [];

        for (var i = 0; i < selectedBasketItems.length; i++) {
            selectedIds.push(parseInt(selectedBasketItems[i].id));
        }

        return $mdDialog.show({
            templateUrl: "modules/basket/templates/basket-item-bulk-change-dialog.tmpl.html",
            controller: "BasketItemBulkChangeDialogCtrl",
            controllerAs: "basketItemBulkChangeDialogCtrl",
            parent: angular.element(document.body),
            clickOutsideToClose: false,
            locals: {
                selectedIds: selectedIds,
                bkhId: bkhId,
                viewMode: viewMode,
                helperDialogParams: getControlHelperDialogParams(null, null)
            }
        });
    }

    function validateOGD(basketSupplierHeader,  getErrorlist, hasOGDEnabled) {
        if (basketSupplierHeader && basketSupplierHeader.ogd) {
            const ogdEnabled = typeof hasOGDEnabled == 'boolean' ? hasOGDEnabled : impactX.isDefined(basketSupplierHeader, 'ogd.reportOGD.value');
            return dataGen.postAsForm({}, {
                    bksId: basketSupplierHeader.id,
                    hasSPOEnabled: impactX.isDefined(basketSupplierHeader, 'subsequentPurchaseOrderEnabled.value'),
                    hasOGDEnabled: ogdEnabled,
                    getErrorlist: getErrorlist
                },
                '/basket/opengovernmentdata/validate').then(function (answer) {
                    if (impactX.isDefined(answer, 'data.isInvalid')) {
                        basketSupplierHeader.ogd.isInvalid = true;
                    }
                    else {
                        basketSupplierHeader.ogd.isInvalid = false;
                    }
                },
                function () {
                    basketSupplierHeader.ogd.isInvalid = true;
                });
        }
    };

    function validateSPO(basketSupplierHeader, getErrorlist) {
        const param = {
            id: basketSupplierHeader.id,
            hasSPOEnabled: basketSupplierHeader.subsequentPurchaseOrderEnabled.value,
            getErrorlist: getErrorlist
        };
       return dataGen.postAsForm({}, param, '/editspo/bks/validate').then(
            function (answer) {
                if(impactX.isDefined(answer, 'data.isInvalid')) {
                    basketSupplierHeader.spoisinvalid = true;
                }
                else {
                    basketSupplierHeader.spoisinvalid = false;
                }
            },
            function (){
                basketSupplierHeader.spoisinvalid = true;
            });
    };

    function getControlHelperDialogParams(bks, bki) {
        const helperDialogParams = {
            ctrlString: 'ctu'
        };
        if (bks && bks.id) {
            helperDialogParams.bksId = bks.id;
        }
        if (bki && bki.id) {
            helperDialogParams.bkiId = bki.id;
        }
        return helperDialogParams;
    }

    function openForwardDialog(bkhId) {
        return $mdDialog.show({
            templateUrl: "modules/basket/templates/basket-forward-dialog.tmpl.html",
            controller: "BasketForwardDialogCtrl",
            controllerAs: "basketForwardDialogCtrl",
            parent: angular.element(document.body),
            clickOutsideToClose: false,
            locals: {
                bkhId: bkhId
            }
        });
    }

    return {
        setLandingPageIndex: setLandingPageIndex,
        initLandingPages: initLandingPages,
        resolveLandingPage: resolveLandingPage,
        openBasketControlStructureDialog: openBasketControlStructureDialog,
        openBasketAddressDialog: openBasketAddressDialog,
        openDatesDialog: openDatesDialog,
        openRequestedDatesDialog: openRequestedDatesDialog,
        openBulkChangeDialog: openBulkChangeDialog,
        validateSPO: validateSPO,
        validateOGD: validateOGD,
        getControlHelperDialogParams: getControlHelperDialogParams,
        openForwardDialog: openForwardDialog,
        openServicePeriodDialog: openServicePeriodDialog
    };
}